var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.316665 3.26595L2.96667 5.62294C3.17778 5.93234 3.48889 6.11111 3.81667 6.11111L16.1722 6.11111C16.5 6.11111 16.8111 5.93234 17.0222 5.62294L19.6722 3.26595C19.8833 3.00468 20 2.66089 20 2.29648L20 0L0 -1.74846e-06L-2.00164e-07 2.2896C-2.32021e-07 2.65401 0.116668 3.00467 0.327779 3.25907L0.316665 3.26595ZM4.79167 7.33333L15.2083 7.33333C15.7836 7.33333 16.25 7.88054 16.25 8.55556L16.25 9.77778C16.25 10.4528 15.7836 11 15.2083 11L4.79167 11C4.21637 11 3.75 10.4528 3.75 9.77778L3.75 8.55555C3.75 7.88054 4.21637 7.33333 4.79167 7.33333ZM5 12.2222L14.9998 12.2222L15 17.1973C15 19.8484 12.76 22 10.0001 22C7.24016 22 5.00021 19.8484 5.00021 17.1973L5 12.2222Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenMedium);
export default __webpack_public_path__ + "static/media/pen-medium.1c90dec2b35d728e80d4f897bc59f505.svg";
export { ForwardRef as ReactComponent };